module.exports = __webpack_public_path__ + "media/images/tl/banner/zh-hant-2-light-852153ff70f8da10865b9e3bfc963caf.jpg";